import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Sidebar from "../../common/components/sidebar";
import ConsentList from "./consentList";
import ConsentDetail from "./consentDetail";
import ConsentSetting from "./setting";
import ConsentReward from "./rewards";
import ConsentCoupon from "./rewards/coupon";
import ConsentAllocation from "./rewards/allocation";
import ConsentEmail from "./rewards/email";

const Consents = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div
      className="flex w-full items-start"
      style={{ height: window.innerHeight - 65 }}
    >
      <Sidebar />
      <div className="size-full overflow-y-auto ">
        <Routes>
          <Route path="/" element={<ConsentList />} />
          <Route path="/consent-setting" element={<ConsentSetting />} />
          <Route path="/consent-reward" element={<ConsentReward />} />
          <Route path="/consent-coupon" element={<ConsentCoupon />} />
          <Route path="/consent-allocation" element={<ConsentAllocation />} />
          <Route path="/consent-email" element={<ConsentEmail />} />
          <Route path="/consent-detail/:id" element={<ConsentDetail />} />
        </Routes>
      </div>
    </div>
  );
};

export default Consents;
